import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1698F1',
      light: '#6098C9',
      dark: '#0D5A9F',
      contrastText: '#FDFBFB',
    },
    secondary: {
      main: '#B8ADA8',
      light: '#BBB1B1',
      dark: '#8A7E7A',
      contrastText: '#FDFBFB',
    },
    tertiary: {
      main: '#9E07A1',
      light: '#B562B5',
      dark: '#6A0371',
      contrastText: '#FDFBFB',
    },
    error: {
      main: '#CA1E07',
      light: '#DB9C94',
      dark: '#8F1405',
      contrastText: '#FDFBFB',
    },
    warning: {
      main: '#E05C3D',
      light: '#FFA685',
      dark: '#E45B24',
      contrastText: '#FDFBFB',
    },
    info: {
      main: '#82A7BF',
      light: '#052e46',
      dark: '#40545F',
      contrastText: '#FDFBFB',
    },
    success: {
      main: '#049141',
      light: '#0EBD60',
      dark: '#026D31',
      contrastText: '#FDFBFB',
    },
    divider: 'rgba(255,255,255,0.12)',
    text: {
      primary: '#FFFFFF',
      secondary: '#D2E4FD',
      disabled: '#766C6C',
    },
    background: {
      default: '#161616',
      paper: '#1D1B26',
      phonecallSplitButton: '#127F79',
      note: {
        TASKCREATED: '#15283A', // Une couleur foncée mais lisible
        TASKDONE: '#003816', // Un vert plus sombre
        DEFAULT: '#2E2E2E', // Gris foncé amélioré pour éviter le blanc trop clair
      },
    },
    icon: {
      tickets: {
        background: '#1698F1',
        contrast: '#FFFFFF',
      },
      tasks: {
        background: '#1698F1',
        contrast: '#FFFFFF',
      },
      messages: {
        background: '#297BA7',
        contrast: '#FFFFFF',
      },
      notes: {
        background: '#D4A713',
        contrast: '#FFFFFF',
      },
      phonecalls: {
        background: '#127F79',
        contrast: '#FFFFFF',
      },
    },
    switch: {
      messages: {
        buttonChecked: '#297BA7',
        buttonUnchecked: '#000000',
        trackChecked: '#297BA7',
        trackUnchecked: '#000000',
      },
      notes: {
        buttonChecked: '#D4A713',
        buttonUnchecked: '#000000',
        trackChecked: '#D4A713',
        trackUnchecked: '#000000',
      },
      phonecalls: {
        buttonChecked: '#127F79',
        buttonUnchecked: '#000000',
        trackChecked: '#127F79',
        trackUnchecked: '#000000',
      },
      actionOnCommand: {
        buttonChecked: '#ff7133',
        buttonUnchecked: '#000000',
        trackChecked: '#ff7133',
        trackUnchecked: '#000000',
      },
    },
    borders: {
      main: '#B0B0B0',
      light: '#A5A5A5',
      dark: '#2E2E2E',
    },
    button: {
      YUSEN: {
        main: '#1E4F76', // Bleu foncé
        hover: '#144B68', // Hover (encore plus foncé)
        active: '#0C3851', // Active (presque marine)
      },
      DPD: {
        main: '#D47A00', // Orange foncé
        hover: '#B86B00', // Hover (plus foncé)
        active: '#9C5C00', // Active (très foncé)
      },
      UPS: {
        main: '#F1B800', // Jaune vif
        hover: '#F1A000', // Hover (plus doré)
        active: '#D79000', // Active (plus profond)
      },
    },
  },
});

export default darkTheme;
